import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Alert } from "@mui/material";

export default function SaveToBankPromptDialog({ open, sourceLabel, onChoose, onClose, warning }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>This {sourceLabel} came from the Knowledge Bank</DialogTitle>
      <DialogContent>
        <Box sx={{ fontSize: "13.5px", color: "var(--color-ink-3)", mb: "12px" }}>
          You edited a copy of a bank item. What should happen to your change?
        </Box>
        {warning && <Alert severity="warning" data-testid="save-to-bank-warning">{warning}</Alert>}
      </DialogContent>
      <DialogActions sx={{ flexDirection: "column", alignItems: "stretch", gap: "8px", px: "20px", pb: "18px" }}>
        <Box component="button" onClick={() => onChoose("UPDATE_SOURCE")}
          sx={{ textAlign: "left", p: "10px 14px", borderRadius: "10px", border: "1.5px solid var(--color-hairline-cloud)", bgcolor: "transparent", cursor: "pointer", fontFamily: "inherit", fontSize: "13.5px", fontWeight: 600 }}>
          Update the original bank item
        </Box>
        <Box component="button" onClick={() => onChoose("NEW_ITEM")}
          sx={{ textAlign: "left", p: "10px 14px", borderRadius: "10px", border: "1.5px solid var(--color-hairline-cloud)", bgcolor: "transparent", cursor: "pointer", fontFamily: "inherit", fontSize: "13.5px", fontWeight: 600 }}>
          Save as a new bank item
        </Box>
        <Box component="button" onClick={() => onChoose("KEEP_LOCAL")}
          sx={{ textAlign: "left", p: "10px 14px", borderRadius: "10px", border: "1.5px solid var(--color-hairline-cloud)", bgcolor: "transparent", cursor: "pointer", fontFamily: "inherit", fontSize: "13.5px", fontWeight: 600 }}>
          Keep this edit local to this class only
        </Box>
      </DialogActions>
    </Dialog>
  );
}
